export default function Prices() {
  const tabsBtn = document.querySelectorAll('.prices .tabs-container .tab');

  if (tabsBtn) {
    tabsBtn.forEach((tab) => {
      tab.addEventListener('click', function (e) {
        const parentSection = this.closest('.prices');
        const block = parentSection.querySelector('#' + this.dataset.tab);
        if (!block) {
          return;
        }
        const show = parentSection.querySelector('.show');
        if (show) {
          show.classList.remove('show');
        }
        parentSection.querySelector('.tab-active').classList.remove('tab-active');
        this.classList.add('tab-active');
        block.classList.add('show');
      });
    });
  }

  // открытие ссылки дисконтной программы, по нажатию цены "по карте" в мобилке
  // const tables = document.querySelectorAll('.table_list');
 // if (tables) {
//    tables.forEach((table) => {
   //   const btnsMap = table.querySelectorAll('.by_map');
     // const link = table.querySelector('.by-map-link');
     // if (btnsMap) {
       // btnsMap.forEach((btn) => {
         // btn.addEventListener('click', () => {
           // if (link) {
             // link.click();
          //  }
   //       });
     //   });
  //    }
 //   });
 //  }
}
